module.exports = __webpack_public_path__ + "static/img/prq6.8ad8bca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/prq6.jpg
// module id = DXuv
// module chunks = 2